<template>
	<div>


	<div class="row" v-if="canManageFiles">
		<form class="my-form">
			<p>Upload multiple files with the file dialog or by dragging and dropping images onto the window below</p>
			<input type="file" ref="document" id="fileElem" multiple v-on:change="handleFilesChange">
			<label class="btn btn-primary" for="fileElem">Add Files</label>
		</form>
	</div>

	<div class="row">
		<div id="dropArea"
			v-on:dragstart="handleDragStart"
			v-on:dragover="handleDragOver"
			v-on:dragenter="handleDragEnter"
			v-on:dragleave="handleDragLeave"
			v-on:dragend="handleDragEnd"
			v-on:drop="handleDrop"
			v-on:drag="handleDrag"
		>
			<div class="file_card" v-for="file in documentLibraryFiles">
				<a :href="getFileUrl(file)">
					<div class="icon" v-html="file.icon"></div>
				</a>
				<div class="caption">{{ file.file_name }}</div>
				<div class="actions" v-if="canManageFiles"><span class="btn btn-xs btn-danger" v-on:click="deleteFile(file)"><i class="fas fa-trash-alt"></i>&nbsp;Remove</span></div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>

</div>


</template>

<style scoped>
#dropArea {
  border: 2px solid #ccc;
  border-radius: 20px;
  width: 100%;
  font-family: sans-serif;
  margin: 0px auto;
  padding: 32px;
}
#dropArea.highlight {
  border-color: blue;
}
p {
  margin-top: 0;
}
.my-form {
  margin-bottom: 10px;
}
#gallery {
  margin-top: 10px;
}
#gallery img {
  width: 150px;
  margin-bottom: 10px;
  margin-right: 10px;
  vertical-align: middle;
}
.button {
  display: inline-block;
  padding: 10px;
  background: #00f;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.button:hover {
  background: #0f0;
}
#fileElem {
  display: none;
}
.file_card {
	width: 112px;
	border: 1px #ccc;
	border-radius: 8px;
	padding: 0px;
	margin: 16px;
	float: left;
}
.file_card .caption {
	width: 100%;
	height: 80px;
	text-overflow: hidden;
	margin: 8px auto;
	text-align: center;
	font-size: 1em;
	word-wrap: break-word;
}
.file_card .icon {
	width: 112px;
	height: 96px;
	padding: 16px 16px 0 16px; /* Padding left / right / top for the image */
}
.file-card .icon:hover {
	cursor: pointer;
}
.actions {
	text-align: center;
}
</style>

<script>


export default {
	components: {  },
        props: {
            document_library_id: {
            	type: Number,
            	default: 0
            },
            can_manage_files: {
            	type: Boolean,
            	default: false
            }
        },
		data: function () {
		return {
			documentLibraryId: this.document_library_id,
			documentLibrary: { name: "" },
			documentLibraryFiles: null,
			canManageFiles: this.can_manage_files
		}
	},
	computed: {
	},
	mounted() {
		console.log('Document Library component mounted.');
		this.setupDefaults();
		this.getDocumentLibraryDetails();
		this.getDocumentLibraryFiles();
	},
	methods: {
		setupDefaults() {
			console.log('Setting defaults');
			// var dropArea = this.$refs.dropArea;
			// let dropArea = document.getElementById("dropArea")

			// // Prevent default drag behaviors
			// ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
			// 	dropArea.addEventListener(eventName, function(event) {
			// 		event.preventDefault();
			// 		event.stopPropagation();
			// 	}, false);
			// 	document.body.addEventListener(eventName, function(event) {
			// 		event.preventDefault();
			// 		event.stopPropagation();
			// 	}, false);
			// })

			// Highlight drop area when item is dragged over it
			// ;['dragenter', 'dragover'].forEach(eventName => {
			// 	dropArea.addEventListener(eventName, function(event) {
			// 		dropArea.classList.add('highlight');
			// 	}, false);
			// })

			// ;['dragleave', 'drop'].forEach(eventName => {
			// 	dropArea.addEventListener(eventName, function(event) {
			// 		dropArea.classList.remove('highlight');
			// 	}, false);
			// })

			// // Handle dropped files
			// dropArea.addEventListener('drop', handleDrop, false);

		},
		handleDragStart(event) {
			console.log('Drag Start');
		},
		handleDragOver(event) {
			console.log('Drag Over');
			event.preventDefault();
			event.stopPropagation();
			dropArea.classList.add('highlight');
		},
		handleDragEnter(event) {
			console.log('Drag Enter');
			event.preventDefault();
			event.stopPropagation();
			dropArea.classList.add('highlight');
		},
		handleDragLeave(event) {
			console.log('Drag Leave');
			event.preventDefault();
			event.stopPropagation();
			dropArea.classList.remove('highlight');
		},
		handleDragEnd(event) {
			console.log('Drag End');
		},
		handleDrop(event) {
			console.log('Drag Drop');
			event.preventDefault();
			event.stopPropagation();
			dropArea.classList.remove('highlight');
		  let dt = event.dataTransfer
		  let files = dt.files

		  this.handleFiles(files)

		},
		handleDrag(event) {
			console.log('Drag');
		},
		handleFilesChange()
		{
			console.log(this.$refs.document.files);
			this.handleFiles(this.$refs.document.files);
		},
		handleFiles(files) {
			if (this.canManageFiles === false) {
				this.$message({message: 'You do not have permission to upload files.', type: 'error'});
				return;
			}

			console.log(files);
		  ([...files]).forEach(this.uploadFile)
		},
		uploadFile(file) {

			let formData = new FormData()
			formData.append('file', file)

			axios.post('/api/v1/document_library/' + this.documentLibraryId + '/files', formData).then((response) => {
				console.log(response.data);
				this.$message({message: 'The file was uploaded successfully.', type: 'success'});
				this.documentLibraryFiles.push(response.data);
				this.documentLibraryFiles = _.sortBy(this.documentLibraryFiles, ['file_name']);
				// this.documentLibrary = response.data;
			}).catch((error) => {
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem uploading the file.', type: 'error'});
			});


		},
		getFileUrl(file)
		{
			return "/document_library/" + this.documentLibraryId + "/files/" + file.id;
		},
		deleteFile(file)
		{
			console.log('Deleting file');
			if (this.canManageFiles === false) {
				this.$message({message: 'You do not have permission to remove files.', type: 'error'});
				return;
			}
			console.log(file);

			let formData = new FormData()
			formData.append('_method', 'DELETE')

			axios.post('/api/v1/document_library/' + this.documentLibraryId + '/files/' + file.id, formData).then((response) => {
				console.log(response.data);
				this.$message({message: 'The file was removed successfully.', type: 'success'});
				this.documentLibraryFiles = _.filter(this.documentLibraryFiles, function(f) { return f.id != file.id; });
				// this.documentLibraryFiles.push(response.data);
				this.documentLibraryFiles = _.sortBy(this.documentLibraryFiles, ['file_name']);
			}).catch((error) => {
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem removing the file.', type: 'error'});
			});
		},
		getDocumentLibraryDetails() {
			console.log('getDocumentLibraryDetails');
			axios.get('/api/v1/document_library/' + this.documentLibraryId).then((response) => {
				console.log(response.data);
				this.documentLibrary = response.data;
			}).catch((error) => {
				this.$message({message: 'There was a problem loading the document library details.', type: 'error'});
			});
		},
		getDocumentLibraryFiles() {
			console.log('getDocumentLibraryFiles');
			axios.get('/api/v1/document_library/' + this.documentLibraryId + '/files').then((response) => {
				console.log(response.data);
				this.documentLibraryFiles = response.data;
			}).catch((error) => {
				this.$message({message: 'There was a problem loading the document library files.', type: 'error'});
			});
  		},
		handleHTTPError(error) {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data); // Error message
					console.log(error.response.status);
					console.log(error.response.headers);
					// this.$message({message: 'Error: ' + error.response.data, type: 'error'});
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
					// this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					// this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				}
				console.log(error.config);
		},
	}
}
</script>